import store from "../store";
export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {};
      },
      created() {},
      computed: {
        appData() {
          return store.state.appData
        },
        themeOssUrl() {
          return "https://oss.xtlinks.cn/applet/theme" + this.appData.merThemeId;
        },
      },
    });
  },
};
